import PropTypes from 'prop-types';
import React from 'react';
import withRouter from '../withRouter';
import RipEstateForm from './estate/Form';
import RipLayout from './RipLayout';

const Estate = ({ navigate, params: { id } }) => (
    <RipLayout>
        <RipEstateForm
            back={`/rip/${id}/impots`}
            id={id}
            onSubmitSuccess={() => navigate(`/rip/${id}/finances`)}
        />
    </RipLayout>
);

Estate.propTypes = {
    navigate: PropTypes.func,
    params: PropTypes.shape({
        id: PropTypes.string.isRequired,
    }).isRequired,
};

export default withRouter(Estate);
